import {FtpFileConfiguration} from './FtpFileConfiguration';

export class GetFtpFileConfiguration extends FtpFileConfiguration {
exitStatusOnFileExists: boolean | null;
exitStatusOnNoFile: boolean | null;
removeRemoteFile: boolean | null;
}

